fx.ns("models", class ProductPrint extends  models.Creation {

	constructor(data)
	{
		super(data);

        this.product_type_id = models.ProductType.PRINT;
	}

    get isScrapBooking()
    {
        return this.creationOption.option.editor_code.startsWith("scrapbooking-")
    }

    get isBox()
    {
        return this.creationOption.option.editor_code.startsWith("box-")
    }

    get prints()
    {
        return this.elements;
    }

    get numPrints()
    {
        var numPrints = 0;
        for(var i = 0; i < this.elements.length; i++)
        {
            let print = this.elements.getItemAt(i);
            if(print.quantity)
            {
                numPrints+=print.quantity;
            }
        }
        return numPrints;
    }

    get pricePerPrint()
    {
        return (this.calculatePricePerPrint() * fx.get("lang").tax).toFixed(2); 
    }

    get totalPrice()
    {
		return this.calculatePrice();
    }

    get pageWidth()
    {
        let width = 0;

        let shape = this.creationOption && this.creationOption.format ? this.creationOption.format.style : this.shape_option;
        switch(shape)
        {
            case "square":
                width = 210;
                break;
            case "portrait":
                width = 210;
                break;
            case "landscape":
                width = 300;
                break;
        }
        return width;
    }

    get pageHeight()
    {
        let height = 0;
        let shape = this.creationOption && this.creationOption.format ? this.creationOption.format.style : this.shape_option;
        switch(shape)
        {
            case "square":
                height = 210;
                break;
            case "portrait":
                height = 300;
                break;
            case "landscape":
                height = 210;
                break;
        }
        return height;
    }

    get creationOption()
    {
        return this._creationOption;
        //return this.creationOptions.find({formatid : this.formatid, option_id : this.optionid})
    }

    set creationOption(val)
    {
        this._creationOption = val;
    }

     // to override
	get minPages()
	{
		return this.creationOption.min_pages;
	}

    get maxPages()
	{
		return this.creationOption.max_pages;
	}

    
	get numberPages()
	{
        let num = 0;
        for(let i = 0; i < this.elements.length; i++)
            num += this.elements.getItemAt(i).quantity;

		return num;
	}

    calculatePricePerPrint()
    {
        let pricePerPrint = this.creationOption.price_base;
        let nbPrint = Math.max( this.numPrints , this.minPages);
        let minQty = -1;

        for(let i = 0; i < this.creationOption.unit_prices.length; i++)
        {
            let unitPrice = this.creationOption.unit_prices[i];
            if(nbPrint >= unitPrice.min_qty && unitPrice.min_qty > minQty)
            {
                minQty = unitPrice.min_qty;
                pricePerPrint = unitPrice.price;
            }
        }

        return pricePerPrint;
    }
	
	calculatePrice()
	{
        let price = 0;
        if (this.isBox || this.isScrapBooking)
        {
            // price of box is price_base + extra page > 20
            price = this.creationOption.price_base;
            if (this.numPrints > this.minPages)
                price +=  (this.numPrints - this.minPages) * this.calculatePricePerPrint()
        }
        else
        {
            price = Math.max( this.numPrints , this.minPages) * this.calculatePricePerPrint();
        }
        
        price = price * fx.get("lang").tax;

        return price .toFixed(2) + " €" ;
	}

    addPrint(referenceElement)
    {
        let newElement = new models.ProductPrintPage({creation_id : this.id, layoutid : 0});
			
		let index = referenceElement ? ((referenceElement && referenceElement !== true) ? (this.elements.indexOf(referenceElement)+1) : 0) : this.elements.length;

		this.elements.addItemAt( index, newElement );

		newElement.addBackground();

		this.updateNumbering();

        return newElement;
    }


    // a print is its photo : emptied by a deleted photo, it is removed rather than left blank
    // (photos canceled in FilesNotUploaded, creation 4394288 : 6 blank prints, 2 went unnoticed)
    removePhoto(photo)
    {
        let prints = [];
        for (let i = 0; i < this.elements.length; i++)
        {
            let print = this.elements.getItemAt(i);
            if (print.photosComponents.some(component => component.content == photo.id))
                prints.push(print);
        }

        super.removePhoto(photo);

        for (let i = 0; i < prints.length; i++)
        {
            if (prints[i].photosComponents.every(component => !component.content))
                prints[i].delete();
        }
    }

    // apply layout to all elements
	applyLayout( layout )
	{
		for(let i = 0; i < this.elements.length; i++)
        {
            let element = this.elements.getItemAt(i);

            let pageWidth = this.pageWidth;
            let pageHeight = this.pageHeight;

            let shape;

            let photoComponent = element.photosComponents.getItemAt(0);

            if (pageWidth != pageHeight)
            {
                if (photoComponent)
                {
                    shape = "square";
                    if (photoComponent.width > photoComponent.height)
                        shape = "landscape";
                    else
                    if (photoComponent.width < photoComponent.height)
                    {
                        shape = "portrait";
                        pageWidth = this.pageHeight;
                        pageHeight = this.pageWidth;
                    }       
                }
            }

            let layoutPhotoComponent = layout.getPhotos()[0];
            if (layoutPhotoComponent && photoComponent)
                layoutPhotoComponent.rotation_inner = photoComponent.rotation_inner;

            if (!shape || layout.shape == shape)
                element.applyLayout( layout, pageWidth, pageHeight);
        }
	}

});


fx.ns("models.ProductPrint").SQUARE = "square";
fx.ns("models.ProductPrint").LANDSCAPE = "landscape";
